import { useEffect, useState } from "react";
import { Button, Form, Modal, Spinner, Table } from "react-bootstrap";
import DashboardLayout from "./DashboardLayout";

 const BASE_API_URL = process.env.REACT_APP_API_URL;
const LinkedInPostComment = () => {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [selectedPost, setSelectedPost] = useState(null);
  const [comment, setComment] = useState("");


  const fetchPosts = () => {
    setLoading(true);
    fetch(`${BASE_API_URL}/posts`)
      .then((res) => res.json())
      .then((data) => setPosts(data))
      .catch((err) => {
        console.error('Error fetching posts:', err);
        setPosts([]);
      })
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    fetchPosts();
  }, []);

  // Simple AI-like logic to generate default comment based on title
const generateComment = (title) => {
  const lowerTitle = title.toLowerCase();

  if (lowerTitle.includes("developer") || lowerTitle.includes("engineer") || lowerTitle.includes("sde")) {
    return "Great to see the team growing! If you're looking to reach more qualified developers quickly, Jobbox.one (https://jobbox.one) is a free platform worth checking out for your next opening.";
  } else if (lowerTitle.includes("frontend") || lowerTitle.includes("front-end") || lowerTitle.includes("react") || lowerTitle.includes("ui")) {
    return "Exciting opportunity! For frontend roles specifically, Jobbox.one (https://jobbox.one) connects you with vetted candidates at no cost — might be a good addition to your hiring pipeline.";
  } else if (lowerTitle.includes("backend") || lowerTitle.includes("back-end") || lowerTitle.includes("java") || lowerTitle.includes("python") || lowerTitle.includes("node")) {
    return "Wishing you luck finding the right fit! If you'd like to widen your candidate pool for free, Jobbox.one (https://jobbox.one) is worth a look for backend hiring.";
  } else if (lowerTitle.includes("marketing") || lowerTitle.includes("sales") || lowerTitle.includes("business development")) {
    return "Great opportunity for the right candidate! To reach more applicants at no cost, you might find Jobbox.one (https://jobbox.one) useful for this kind of role.";
  } else if (lowerTitle.includes("hr") || lowerTitle.includes("human resource") || lowerTitle.includes("recruiter") || lowerTitle.includes("talent")) {
    return "Always great to see teams expanding their HR function! Jobbox.one (https://jobbox.one) is a free platform that might help you source candidates faster.";
  } else if (lowerTitle.includes("remote") || lowerTitle.includes("work from home") || lowerTitle.includes("wfh")) {
    return "Remote roles like this attract a lot of interest! To reach a wider talent pool for free, consider listing it on Jobbox.one (https://jobbox.one) as well.";
  } else if (lowerTitle.includes("urgent") || lowerTitle.includes("immediate")) {
    return "For urgent hiring needs, speed matters. Jobbox.one (https://jobbox.one) lets you post for free and start getting applications right away — could help you close this faster.";
  } else if (lowerTitle.includes("intern") || lowerTitle.includes("fresher") || lowerTitle.includes("entry level")) {
    return "Great opportunity for early-career talent! Jobbox.one (https://jobbox.one) is free to use and has a strong pool of freshers and interns actively job hunting.";
  } else if (lowerTitle.includes("hiring")) {
    return "Wishing you success with this search! If you'd like more visibility for the role, Jobbox.one (https://jobbox.one) is a free platform worth exploring.";
  } else {
    return "Best of luck with the hiring process! If you're open to it, Jobbox.one (https://jobbox.one) is a free way to reach more qualified candidates for roles like this.";
  }
};

  const handleQuickComment = (post) => {
    setSelectedPost(post);
    setComment(generateComment(post.title));
    setShowModal(true);
  };

  const handleSendComment = async () => {
    try {
      await navigator.clipboard.writeText(comment);
      window.open(selectedPost.url, "_blank");  // Open post in new tab
     // alert("✅ Comment copied! Paste it on LinkedIn as jobbox.one.");
      setShowModal(false);
    } catch (err) {
      console.error("Error copying comment or opening post:", err);
      alert("⚠️ Failed to copy comment. Please try again.");
    }
  };




  return (
   <DashboardLayout>
      <div className="mb-4">
        <h2 className="fw-bold mb-1" style={{ color: '#14213D', letterSpacing: '-0.01em' }}>
          🔎 Scraped LinkedIn Hiring Posts
        </h2>
        <p className="text-muted mb-0">
          Review scraped posts and send quick comments straight from here
        </p>
      </div>

      {loading ? (
        <div
          style={{
            textAlign: 'center',
            padding: '60px 0',
            backgroundColor: '#FFFFFF',
            borderRadius: '16px',
            boxShadow: '0 8px 24px rgba(20, 33, 61, 0.06)',
            border: '1px solid #ECEEF3',
          }}
        >
          <Spinner animation="border" style={{ color: '#0073b1' }} />
          <p style={{ marginTop: '14px', color: '#6B7280', fontSize: '14px' }}>Loading posts...</p>
        </div>
      ) : posts.length === 0 ? (
        <div
          style={{
            textAlign: 'center',
            padding: '70px 20px',
            backgroundColor: '#FFFFFF',
            borderRadius: '16px',
            boxShadow: '0 8px 24px rgba(20, 33, 61, 0.06)',
            border: '1px solid #ECEEF3',
          }}
        >
          <div style={{ fontSize: '40px', marginBottom: '12px' }}>😕</div>
          <p style={{ fontSize: '16px', color: '#3D4457', marginBottom: '4px', fontWeight: 600 }}>
            No posts found
          </p>
          <p style={{ fontSize: '14px', color: '#8890A0', marginBottom: '24px' }}>
            Scraping may have completed with nothing new, or hasn't run yet.
          </p>
          <Button
            onClick={fetchPosts}
            style={{
              backgroundColor: '#0073b1',
              border: 'none',
              padding: '10px 26px',
              borderRadius: '999px',
              fontWeight: 600,
              boxShadow: '0 6px 16px rgba(0, 115, 177, 0.28)',
            }}
          >
            🔄 Scrape Again
          </Button>
        </div>
      ) : (
        <>
          <div
            style={{
              backgroundColor: '#FFFFFF',
              borderRadius: '16px',
              boxShadow: '0 8px 24px rgba(20, 33, 61, 0.06)',
              border: '1px solid #ECEEF3',
              overflow: 'hidden',
            }}
          >
            <div style={{ height: '4px', background: 'linear-gradient(90deg, #0073b1, #14213D)' }} />
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                padding: '16px 20px',
                borderBottom: '1px solid #ECEEF3',
              }}
            >
              <span style={{ fontWeight: 700, color: '#14213D', fontSize: '15px' }}>
                {posts.length} post{posts.length !== 1 ? 's' : ''} found
              </span>
              {/* <Button
                variant="outline-primary"
                size="sm"
                onClick={fetchPosts}
                style={{ borderRadius: '999px', fontWeight: 600, borderColor: '#0073b1', color: '#0073b1', padding: '6px 16px' }}
              >
                🔄 Scrape Again
              </Button> */}
            </div>

            <Table hover responsive className="mb-0" style={{ marginLeft: 0 }}>
              <thead>
                <tr style={{ textAlign: 'left', backgroundColor: '#F7F8FA' }}>
                  <th style={{ padding: '14px 20px', fontSize: '13px', color: '#6B7280', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.03em', border: 'none' }}>Title</th>
                  <th style={{ padding: '14px 20px', fontSize: '13px', color: '#6B7280', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.03em', border: 'none' }}>Link</th>
                  <th style={{ padding: '14px 20px', fontSize: '13px', color: '#6B7280', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.03em', border: 'none' }}>Comment</th>
                </tr>
              </thead>
              <tbody>
                {posts.map((post, index) => (
                  <tr key={index} style={{ borderBottom: '1px solid #ECEEF3' }}>
                    <td style={{ padding: '14px 20px', verticalAlign: 'middle', color: '#14213D', fontSize: '14px' }}>
                      <span style={{ marginRight: '8px' }}>📄</span>
                      {post.title}
                    </td>
                    <td style={{ padding: '14px 20px', verticalAlign: 'middle' }}>
                      <a
                        href={post.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ color: '#0073b1', fontWeight: 600, fontSize: '14px', textDecoration: 'none' }}
                      >
                        View Post ↗
                      </a>
                    </td>
                    <td style={{ padding: '14px 20px', verticalAlign: 'middle' }}>
                      <button
                        onClick={() => handleQuickComment(post)}
                        style={{
                          backgroundColor: '#0073b1',
                          color: 'white',
                          padding: '7px 16px',
                          border: 'none',
                          borderRadius: '999px',
                          cursor: 'pointer',
                          fontSize: '13px',
                          fontWeight: 600,
                          boxShadow: '0 4px 10px rgba(0, 115, 177, 0.22)',
                        }}
                      >
                        💬 Quick Comment
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        </>
      )}
      {/* 🪟 Modal for editing & sending comment */}
      <Modal show={showModal} onHide={() => setShowModal(false)} size="lg">
        <Modal.Header closeButton style={{ borderBottom: '1px solid #ECEEF3', padding: '18px 24px' }}>
          <Modal.Title style={{ fontSize: '17px', fontWeight: 700, color: '#14213D' }}>Comment on Post</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ padding: '24px' }}>
          <p style={{ fontSize: '14px', color: '#14213D', marginBottom: '14px' }}>
            <strong>Post Title:</strong> {selectedPost?.title}
          </p>
          <div
            style={{
              display: 'flex',
              gap: '10px',
              fontSize: '13px',
              color: '#3D4457',
              backgroundColor: '#F0F7FC',
              border: '1px solid #D6E9F5',
              borderRadius: '10px',
              padding: '12px 14px',
              marginBottom: '20px',
              lineHeight: '1.5',
            }}
          >
            <span>✨</span>
            <span>
              This comment will be copied to your clipboard. After clicking "Send Comment", the LinkedIn post will open — switch to <strong>jobbox.one</strong> and paste the comment manually.
            </span>
          </div>
          <Form.Group>
            <Form.Label style={{ fontSize: '14px', fontWeight: 600, color: '#3D4457' }}>Edit Comment:</Form.Label>
            <Form.Control
              as="textarea"
              rows={4}
              value={comment}
              onChange={(e) => setComment(e.target.value)}
              style={{ borderRadius: '10px', border: '1px solid #D7DBE3', fontSize: '14px' }}
            />
          </Form.Group>
        </Modal.Body>

        <Modal.Footer style={{ borderTop: '1px solid #ECEEF3', padding: '16px 24px' }}>
          <Button
            variant="secondary"
            onClick={() => setShowModal(false)}
            style={{ borderRadius: '999px', fontWeight: 600, padding: '8px 22px' }}
          >
            Cancel
          </Button>
          <Button
            variant="primary"
            onClick={handleSendComment}
            style={{
              borderRadius: '999px',
              fontWeight: 600,
              padding: '8px 22px',
              backgroundColor: '#0073b1',
              borderColor: '#0073b1',
              boxShadow: '0 6px 16px rgba(0, 115, 177, 0.28)',
            }}
          >
            Send Comment  {/* Updated label */}
          </Button>
        </Modal.Footer>
      </Modal>
    </DashboardLayout>
  );
};

export default LinkedInPostComment;